import enUS from './en_US'
import csCZ from './cs_CZ'

export default {
  en: enUS,
  cs: csCZ,
}
